import { AggregationField } from '../../aggregation/fields/aggregationFieldPortfolio';

export interface PortfolioSummarySharedConfigurationState {
    recentlyUsedAggregationFields: AggregationField[];
}

export const initialPortfolioSummarySharedConfigurationState: PortfolioSummarySharedConfigurationState =
    {
        recentlyUsedAggregationFields: [],
    };
